export interface IBChartCreateOptions {
  cont?: string
  id?: string
  options?: object
}

export interface IBChartInstance {
  getId: () => string
}
